import React from 'react';
import {
    SingleBarChartComponent,
    ValueWrapper,
    SingleBarChartWrapper,
    ProgressBar,
    ResultValue,
    ActiveProgressBar,
    ProgressBarSub,
    SubText,
    PercentageWrapper,
    IconWrapper,
    Img,
    Title,
    Header,
} from './style';
import icon from './icon.svg';
import { roundScore } from '../../utils';

interface SingleBarChart {
    title?: string;
    value: number;
    max: number;
    minLabel?: string;
    midLabel?: string;
    maxLabel?: string;
    hasScoreValue: boolean;
    hasScoreLabel: boolean;
    hasUserIcon: boolean;
    hasScoreCheckpoints: boolean;
    titleTag?: 'h2' | 'h3';
    resultLabels: {
        low: string;
        mid: string;
        high: string;
    };
}

const SingleBarChart = (props: SingleBarChart) => {
    const {
        title,
        titleTag,
        value,
        max,
        minLabel,
        midLabel,
        maxLabel,
        hasScoreValue,
        hasScoreLabel,
        hasUserIcon,
        hasScoreCheckpoints,
        resultLabels,
    } = props;

    // todo
    const getLabel = (value: number) => {
        if (value < 40) {
            return resultLabels.low;
        } else if (40 <= value && value < 60) {
            return resultLabels.mid;
        } else if (60 <= value && value <= 100) {
            return resultLabels.high;
        }
    };

    const roundedValue = roundScore(value);

    return (
        <SingleBarChartComponent>
            <Header>
                {title && (
                    <Title>
                        {titleTag === 'h3' && <h3>{title}</h3>}
                        {titleTag !== 'h3' && <h2>{title}</h2>}
                    </Title>
                )}
                <ValueWrapper>
                    {hasScoreLabel && (
                        <>
                            <span className="scoreLabel">
                                {getLabel(roundedValue)}
                            </span>
                        </>
                    )}
                    {hasScoreLabel && hasScoreValue && (
                        <span className="valueSeparator">•</span>
                    )}
                    {hasScoreValue && (
                        <ResultValue>
                            {roundedValue < 100 ? roundedValue : 100}%
                        </ResultValue>
                    )}
                </ValueWrapper>
            </Header>
            <SingleBarChartWrapper>
                <ProgressBar max={max <= 100 ? max : 100}>
                    {hasUserIcon && (
                        <IconWrapper
                            value={roundedValue < 100 ? roundedValue : 100}
                            hasUserIcon={hasUserIcon}>
                            <Img src={icon} />
                        </IconWrapper>
                    )}
                    <ActiveProgressBar
                        value={roundedValue < 100 ? roundedValue : 100}
                    />
                </ProgressBar>
                <ProgressBarSub max={max < 100 ? max : 100}>
                    {minLabel && <SubText minLabel={minLabel} />}
                    <PercentageWrapper
                        percentageNumber={20}
                        hasScoreCheckpoints={hasScoreCheckpoints}
                    />
                    <PercentageWrapper
                        percentageNumber={40}
                        hasScoreCheckpoints={hasScoreCheckpoints}
                    />
                    {midLabel && <SubText midLabel={midLabel} />}
                    <PercentageWrapper
                        percentageNumber={60}
                        hasScoreCheckpoints={hasScoreCheckpoints}
                    />
                    <PercentageWrapper
                        percentageNumber={80}
                        hasScoreCheckpoints={hasScoreCheckpoints}
                    />
                    {maxLabel && <SubText maxLabel={maxLabel} />}
                </ProgressBarSub>
            </SingleBarChartWrapper>
        </SingleBarChartComponent>
    );
};

export default SingleBarChart;
